import { render } from "./LoaderComponent.vue?vue&type=template&id=57b8858f&scoped=true&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=57b8858f&scoped=true&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b8858f"]])

export default __exports__